import { BlogMain } from "../../src/landingPage/views/Blog/BlogMain";
import { NextHead } from "../../src/landingPage/layouts/LayoutComponents/NextHead";
import butter from "../../src/landingPage/utils/butter-client";

const BlogMainPage = ({ posts, count }) => {
  return (
    <>
      <NextHead
        currentPath="/blog"
        title="Blog"
        description="Read Demyst's expert blogs on today's most important issues surrounding external data."
      />
      <BlogMain initialPosts={posts} initialCount={count} />
    </>
  );
};

export default BlogMainPage;

export const getServerSideProps = async () => {
  const response = await butter.post.list({ page: 1, page_size: 7 });
  const { data, meta } = response.data;
  return {
    props: {
      posts: data,
      count: meta.count,
      wrapper: "MarketingWrapper",
    },
  };
};
